import { Injectable, EventEmitter } from '@angular/core';

export class GlobalMessage {
	constructor(public message: string, public date: Date) {}
}

@Injectable()
export class GlobalMessageService {
	public messageAdded$: EventEmitter<GlobalMessage>;
  public errorAdded$: EventEmitter<GlobalMessage>;

	private messages: GlobalMessage[] = [];
  private errors: GlobalMessage[] = [];

  constructor() {
  	this.messageAdded$ = new EventEmitter();
    this.errorAdded$ = new EventEmitter();
  }

  public message(message: string): void {
  	this.messages.unshift(new GlobalMessage(message, new Date()));
  	this.messageAdded$.emit(this.messages[0]);
  }

  public error(message?: string): void {
    this.errors.unshift(new GlobalMessage(message, new Date()));
    this.errorAdded$.emit(this.errors[0]);
  }
}



// WEBPACK FOOTER //
// ./client/app/services/global-message.service.ts